'use strict';

var React = require('react');
var Typography = require('../../DesignSystem/DataDisplay/Typography/Typography.js');
var VerticalSpace = require('../Layouts/VerticalSpace.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var ProContact = function ProContact(props) {
  var name = props.name,
      phone = props.phone,
      email = props.email,
      address = props.address,
      settings = props.settings;
  var show_company_name = settings.show_company_name;
  var street = address.street,
      city = address.city,
      state = address.state,
      zip = address.zip,
      street_line_2 = address.street_line_2;
  var addressFirstLine = "".concat(street).concat(street_line_2 ? ", ".concat(street_line_2) : '');
  var addressSecondLine = "".concat(city ? "".concat(city) : '').concat(state ? ", ".concat(state) : '').concat(zip ? " ".concat(zip) : '');
  return React__default["default"].createElement(React__default["default"].Fragment, null, show_company_name && React__default["default"].createElement(Typography, {
    gutterBottom: true,
    variant: "subtitle2"
  }, name), React__default["default"].createElement(Typography, null, phone), React__default["default"].createElement(Typography, {
    gutterBottom: true
  }, email), React__default["default"].createElement(Typography, null, addressFirstLine), React__default["default"].createElement(Typography, null, addressSecondLine), React__default["default"].createElement(VerticalSpace, {
    height: 16
  }));
};

module.exports = ProContact;
